import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';
import brandLogo from '../assets/brand/horizontal.png';
import './Brand.css';

export type BrandSize = 'sm' | 'md' | 'lg';

export interface BrandProps extends HTMLAttributes<HTMLDivElement> {
  /** Tamanho da logomarca. */
  size?: BrandSize;
  /**
   * Mantido por compatibilidade — a logo horizontal já inclui o wordmark, então
   * hoje não há texto separado a alternar. Volta a ter efeito quando o
   * `simbolo.png` isolado chegar (aí mark-só vs lockup-completo). No-op por ora.
   */
  showWordmark?: boolean;
  /** Texto secundário ao lado da logo (ex.: "Canal de Denúncias"). */
  tagline?: string;
}

/**
 * Logomarca oficial da Contato (D-UI-4). Usa `assets/brand/horizontal.png`
 * (compasso/esquadro + wordmark). Trocar a logo = trocar o import acima (um
 * lugar só → as 4 SPAs herdam). No tema dark, a logo recebe uma placa clara
 * sutil (Brand.css) porque o wordmark azul royal perde contraste sobre o navy
 * — substituir por uma variante de texto claro quando o marketing enviar.
 */
export function Brand({ size = 'md', tagline, className, ...rest }: BrandProps): JSX.Element {
  return (
    <div className={cn('cf-brand', `cf-brand--${size}`, className)} {...rest}>
      <img className="cf-brand__logo" src={brandLogo} alt="Contato — Canal de Denúncias" />
      {tagline && <span className="cf-brand__tagline">{tagline}</span>}
    </div>
  );
}
